import styles from "../../styles/Home/hero-section.module.css"
import Button from "../General/Button"
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { handleAuthModal, changeLoginRegisterToggler } from "../../store/AuthSlice";
import { useState } from "react";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import helpers from "../../utils/helpers";
import Search from "../ProductSearch";
import ProfileMenu from "../Layout/ProfileMenu";
import ProfileDrawer from "../Layout/ProfileDrawer";
import Link from "next/link";
import { useRouter } from "next/router";
import WhatsAppButton from "../WhatsappButton";
import Input from "../General/Input";
import * as Yup from "yup";
import { MixpanelTracking } from "../../MixPanel";
import { setSnackBar } from "../../store/ToastSlice";
import { useFormik } from "formik";

const StyledMic = styled.div`
	color : #D8D8D8;
	border-left : 1px solid #D8D8D8;
	padding : 0 15px;
`

const AnimatedBorderDiv = styled.div`
	&::after {
		content : '';
		display: block;
        width: 30%;
        margin: 10px auto 0 auto;
        background-color: #EC6303;
        height: 3px;
	}

	&:hover::after {
		width : 100%;
		transition : 0.6s;
	}
`

function HeroSection() {
	const router = useRouter();
	const { apiList: { list } } = useSelector((state: any) => state.core);
	const { user } = useSelector((state : any) => state.auth);
	const [showDrawer, setShowDrawer] = useState(false);

	// FUNCTIONS
	// Handle Auth Modal
    const openDialog = (ID = null) => {	
        dispatch(handleAuthModal(true));

        // if(ID) 
        //     dispatch(setRedirectTo(`deals/${ID}`));
    }

	const initialValues = {
        phone: ''
    }
    const dispatch : any = useDispatch();
    const { values, errors, handleSubmit, handleBlur, handleChange, touched } = useFormik({
        initialValues: initialValues,

        validationSchema : Yup.object({
            phone : Yup.number().required('This field is required!').nullable().typeError('Please enter a valid phone number!')
        }),

        onSubmit: (values, action) => {
            MixpanelTracking.getInstance().toWhatsAppChat({
                phone : values.phone
            });
            action.resetForm();
            dispatch(setSnackBar(
                {
                    color : 'success',
                    message : 'Thank you for providing the details!'
                }
            ));
            window.open('https://api.whatsapp.com/send?phone=918655735634', '_blank');
        }
    });

	return (
		<div className=""> 
			<div className={`${styles.heroContainer}`}>
				<div className="header flex justify-between items-center py-[20px] lg:py-[20px] --align">
					<div className="logo">
						<img 
							className={`lg:w-[197px] lg:h-[48px]`}
							src={'/Logo.svg'} 
							alt="logo" 
						/>
					</div>

					<div className="flex items-center">
						<div className="flex gap-x-8 text-theme-black font-[400]">
							<Link className="hidden lg:inline-block" href={'/spot-buying'}>Spot Buying</Link>
							<p className="hidden lg:inline-block cursor-pointer" onClick={() => router.pathname === '/products/[slug]' ? helpers.scrollTo('get-in-touch', 140) : helpers.scrollTo('enquiry-section', 140)}>Bulk Deals</p>
							
							{
								!user.isLoggedIn &&
								<AnimatedBorderDiv className="hidden text-[16px] text-theme-black mr-[50px] cursor-pointer md:block">
									<a href={process.env.NEXT_PUBLIC_SELLER_HOME_PAGE_URL} target="_blank">
										Sell on API Drug
									</a>
								</AnimatedBorderDiv>
							}

						</div>
						{
							user.isLoggedIn ?
							<div>
								<div className={`flex items-center ${styles.burger}`}> 
									<svg onClick={() => setShowDrawer(true)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 cursor-pointer text-[#444444]">
										<path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
									</svg>
								</div> 

								<div className={`flex items-center ml-8 ${styles.getInTouch}`}>
									<ProfileMenu buttonColor = '#444444' />

									<Button 
										onClick = {() => helpers.scrollTo('enquiry-section', 140)} 
										styles="bg-theme-orange text-white ml-7 lg:w-[180px] lg:h-[50px] text-[16px]" 
										destinationEvent = "Scrolled To Footer"
									>
											Get In Touch
									</Button>
								</div>
							</div>
							:
							<div className="button flex items-center">
								<Button onClick={openDialog} styles="bg-theme-orange text-sm lg:text-base text-white font-[400] w-[130px] h-[40px] lg:w-[180px] lg:h-[50px] text-[16px]">Login / Register</Button>
							</div>
						}
					</div>

				</div>

				<div className={`${styles.backgroundContainer} flex flex-col justify-center --align lg:flex-row lg:justify-between lg:items-center lg:mt-[40px]`}>
					<div>
						<h1 className="text-[#294788] text-[40px] font-[600] lg:text-[66px]">Buy Any API,</h1>
						<h1 className="text-[#294788] text-[40px] font-[600] lg:text-[66px] lg:-mt-[15px]">Anytime, At The</h1>
						<h1 className="text-[#294788] text-[40px] font-[600] lg:text-[66px] lg:-mt-[15px]">Best Price</h1>

						<div className="hidden">
							<WhatsAppButton />
						</div>
						
						{/* <Link href="https://api.whatsapp.com/send?phone=918655735634" target="_blank">
							<Button destinationEvent = "External Redirection to WhatsApp | From hero section" styles = "flex bg-[#BDFDC9] border border-[#006475] rounded-[5px] w-[190px] h-[52px]">
								<img className="w-[32px] mr-[10px]" src="/WhatsApp.svg" alt="WA" />
								<p className="text-[18px] font-[600]"> Get Best Quote </p>
							</Button>
						</Link> */}
					</div>

					<img className="hidden lg:inline-block w-[511px] h-[274px]" src="/Home/HeroSectionImage.png" alt="hero_image" />
				</div>

				<div className="--align mt-[30px] lg:w-[50%]">
					<form onSubmit={handleSubmit} className="md:flex md:items-start">
						<div className="md:w-[60%]">
							<Input 
								outerProperties = "rounded border-[rgba(0, 0, 0, 0.10)] bg-[#F5F5F5] pl-[10px]"
								properties='rounded h-[51.9px] placeholder:text-[15px] placeholder:font-[400]'
								name='phone'
								value={values.phone}
								onBlur={handleBlur}
								error={errors.phone}
								touched={touched.phone}
								onChange={handleChange}
								background = "#F5F5F5"
								placeholder = {'Enter Your Phone Number'}
							/>
						</div>

						<Button type = "submit" destinationEvent = "External Redirection to WhatsApp | From hero section" styles = "flex bg-theme-orange rounded-[5px] w-full h-[52px] mt-[10px] text-[#393F46] md:mt-0 md:w-[200px] md:ml-2">
							<img className="w-[24px] mr-[10px]" src="/WhatsAppIcon.svg" alt="WA" />
							<p className="text-[18px] font-[500] text-white"> Get Best Quote </p>
						</Button>
					</form>
				</div>
				
				<div className="--align mt-[30px] lg:mt-[70px] lg:w-[87%] lg:mx-auto">
					<Search 
						shadow 
						searchIconHeight = "w-[25px] lg:w-[40px]"
					/>
				</div>

				<div className="mt-[20px] lg:mt-[40px] --align flex flex-wrap justify-between items-center gap-y-[20px] md:justify-center md:gap-x-[20px] lg:gap-x-[96px]">
					<div className="flex">
						<img className="mr-2" src="/Home/TickCircle.svg" alt="" />
						<p className="text-[16px] text-[#294788e6] font-[600]">Free To Use</p>
					</div>
					<div className="flex">
						<img className="mr-2" src="/Home/TickCircle.svg" alt="" />
						<p className="text-[16px] text-[#294788e6] font-[600]">5000+ Suppliers</p>
					</div>
					<div className="flex">
						<img className="mr-2" src="/Home/TickCircle.svg" alt="" />
						<p className="text-[16px] text-[#294788e6] font-[600]">500+ shipments/month</p>
					</div>
				</div>
				
				<ProfileDrawer show = {showDrawer} onClose = {() => setShowDrawer(false)} />
			</div>
		</div>
	)
}

export default HeroSection